import {isLocalhost} from "@/common/common";

/** Access token name for local storage */
export const accessTokenName = 'catalogueProfileAccessToken';

const { VITE_API_HOST } = import.meta.env;

/** Returns authorization header value */
export const getAuthorizationHeaderValue = (token: string) => (
    `Bearer ${token}`
)

/** Redirects to login page */
export const redirectToLoginPage = () => {
    const url = isLocalhost() ? `${VITE_API_HOST}` : `/`;
    window.location.assign(url);
    // TODO: show login form
}
